import { useEffect } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import { useEspot } from '~/store/Query/api';
import orderedAlphabetical from "~/helpers/orderings";

export const pickupInStoreState = hookstate(false);

export const cuotaState = hookstate({
  banks: [],
  affiliations: [],
  cuotas: null,
});

export const esimState = hookstate(false);

export const formCustom = new Set([
  'dpiConfirm',
  'document_type',
  'day',
  'month',
  'year',
  'identification_due_day',
  'identification_due_month',
  'identification_due_year',
  'id',
  'invoice_type',
  'turn',
  'departamentoid',
  'municipioid',
  'pobladoid',
]);

export const formShipping = new Set([
  'first_name',
  'last_name',
  'fax_1',
  'state_or_province_name',
  'city',
  'address_line_2',
  'address_line_1',
  'email_1',
  'phone_1',
  'allowed_recipient_1',
]);

export const sessionInfo = () => {
  const sessionCustom = Array.from(formCustom).reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_custom_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const sessionShipping = Array.from(formShipping).reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_shipping_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const sessionBilling = [
    'address_line_1',
  ].reduce((acc, key) => {
    const value = sessionStorage.getItem(`form_billing_info.${key}`);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return { sessionCustom, sessionShipping, sessionBilling };
};

export const useFormOrder = () => {
  const config = useEspot('formularios-direcciones');
  const state = useHookstate();
  useEffect(() => {
    if (config.data?.ok) {
      state.set(config.data.body);
    }
  }, [config.data]);
  return state;
};

export const useDeptos = () => {
  const config = useEspot('direcciones');
  const state = useHookstate([]);
  useEffect(() => {
    if (config.data?.ok) {
      const { direcciones: data } = config.data.body;
      orderedAlphabetical(data, 'depto_name');
      data.forEach((depto) => {
        orderedAlphabetical(depto.mpos, 'mpo_name');
        depto.mpos.forEach((mpo) => {
          if (mpo.pob) {
            orderedAlphabetical(mpo.pob, 'pob_name');
          }
        });
      });
      state.set(data);
    }
  }, [config.data]);
  return state;
};
